// Lib
import React from 'react';
import { ToolbarListType } from '../../../../workspace/toolbar/toolbarTypes';
import { useSelector } from 'react-redux';

// Hooks
import { useActiveTiptapEditorCallback } from '../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

// Selectors
import { getCurrentlyEditingElement } from '../../../../element/selection/currentlyEditingSelector';

// Utils
import { isCard, isCommentThread } from '../../../../../common/elements/utils/elementTypeUtils';

// Components
import MobileToolbarDoneButton from './MobileToolbarDoneButton';

interface MobileToolbarEditingDoneButtonProps {
    setDefaultToolbarType: (toolbarType: ToolbarListType) => void;
}

/**
 * If a comment is being edited, pressing this button will submit the comment.
 * It relies on the SubmitOnDone extension being present on the editor.
 * If the card needs to switch to different element types, pressing this button will convert the card.
 */
const MobileToolbarEditingDoneButton: React.FC<MobileToolbarEditingDoneButtonProps> = (props) => {
    const { setDefaultToolbarType } = props;

    const currentlyEditingElement = useSelector(getCurrentlyEditingElement);

    const onClick = useActiveTiptapEditorCallback((editor) => {
        if (!editor) return;

        if (isCommentThread(currentlyEditingElement)) {
            editor.commands.submitOnDone?.();
            return;
        }

        if (isCard(currentlyEditingElement)) {
            editor.commands.attemptUniversalCardConversion?.();
        }
    });

    return <MobileToolbarDoneButton onClick={onClick} setDefaultToolbarType={setDefaultToolbarType} />;
};

export default MobileToolbarEditingDoneButton;
